import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { toggleLoader } from "../shared/actions/setting";

const useAuthorApi = () => {
  const dispatch = useDispatch();
  const [authors, setAuthors] = useState([]);

  const fetchAuthors = () => {
    dispatch(toggleLoader(true));
    axios
      .get(process.env.REACT_APP_HOST + `/authors`)
      .then((res) => {
        setAuthors(res.data);
        dispatch(toggleLoader(false));
      })
      .catch((error) => {
        toast.error("Failed to fetch authors.");
        dispatch(toggleLoader(false));
      });
  };

  const createAuthor = (authorData, onSuccess) => {
    dispatch(toggleLoader(true));
    axios
      .post(process.env.REACT_APP_HOST + `/author/create`, authorData)
      .then((res) => {
        toast.success("Author added successfully!");
        fetchAuthors();
        dispatch(toggleLoader(false));
        onSuccess && onSuccess(res.data);
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "Failed to add author.");
        dispatch(toggleLoader(false));
      });
  };

  const editAuthor = (authorData, onSuccess) => {
    dispatch(toggleLoader(true));
    axios
      .patch(process.env.REACT_APP_HOST + `/author/edit`, authorData)
      .then((res) => {
        toast.success("Author updated successfully!");
        fetchAuthors();
        dispatch(toggleLoader(false));
        onSuccess && onSuccess(res.data);
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "Failed to update author.");
        dispatch(toggleLoader(false));
      });
  };

  useEffect(() => {
    fetchAuthors();
  }, []);

  return {
    authors,
    createAuthor,
    editAuthor,
  };
};

export default useAuthorApi;
